import React, { useEffect, useRef } from 'react';
import Footer from '../components/Footer';
import './PortfolioPage.css';

const projetos = [
  {
    num: '01',
    titulo: 'Sistemas Modulares Personalizados',
    descricao:
      'Exposição de diversas soluções modulares de porta-paletes e mini paletes, adaptadas a diferentes setores e requisitos de armazenamento. Demonstração da flexibilidade e capacidade de personalização para atender cada cliente.',
    foto: '/portfolio/image1.avif',
  },
  {
    num: '02',
    titulo: 'Mini Paletes para E-commerce',
    descricao:
      'Projeto customizado de mini paletes para otimização de estoque em operações de e-commerce. Design compacto e resistente para facilitar o manuseio em ambientes com espaço reduzido e alto volume de pedidos.',
    foto: '/portfolio/image2.avif',
  },
  {
    num: '03',
    titulo: 'Solução de Porta-Paletes para Indústria Alimentícia',
    descricao:
      'Sistema de porta-paletes projetado para atender rigorosos padrões de higiene na indústria alimentícia. Materiais de alta qualidade, fácil limpeza e configuração modular para adaptação a diferentes linhas de produção.',
    foto: '/portfolio/image3.avif',
  },
  {
    num: '04',
    titulo: 'Porta-Paletes Industrial de Grande Porte',
    descricao:
      'Estrutura desenvolvida para armazéns de alto volume com necessidade de otimização vertical. Projeto robusto com capacidade elevada por nível e configuração personalizada por setor.',
    foto: '/portfolio/image4.avif',
  },
  {
    num: '05',
    titulo: 'Estruturas Galvanizadas para Ambiente Externo',
    descricao:
      'Solução em aço galvanizado para operações em ambientes externos ou úmidos, garantindo durabilidade e resistência à corrosão sem perda de desempenho estrutural.',
    foto: '/portfolio/image5.avif',
  },
  {
    num: '06',
    titulo: 'Sistema Flow Rack para Picking Dinâmico',
    descricao:
      'Estrutura de fluxo por gravidade que otimiza o processo de picking com abastecimento pela parte traseira e retirada pela frente, garantindo FIFO e agilidade operacional.',
    foto: '/portfolio/image6.avif',
  },
];

function PortfolioPage() {
  const heroRef = useRef(null);
  const titleRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('port__visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    if (heroRef.current) observer.observe(heroRef.current);
    if (titleRef.current) observer.observe(titleRef.current);
    cardRefs.current.forEach((el) => { if (el) observer.observe(el); });

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="port-hero">
        <div className="port-hero__inner port__fade" ref={heroRef}>
          <p className="port-hero__sub">Projetos que Otimizam Operações</p>
          <p className="port-hero__desc">
            Soluções inteligentes de armazenagem industrial instaladas em galpões, centros de
            distribuição e indústrias por todo o Brasil.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="port-grid-section">
        <div className="port-grid__container">
          <h2 className="port-grid__title port__fade" ref={titleRef}>
            Portfolio
          </h2>

          <div className="port-grid">
            {projetos.map((p, i) => (
              <div
                key={p.num}
                className="port-card port__fade"
                ref={(el) => (cardRefs.current[i] = el)}
                style={{ transitionDelay: `${(i % 3) * 0.12}s` }}
              >
                <div className="port-card__imagem">
                  {p.foto ? (
                    <img src={p.foto} alt={p.titulo} />
                  ) : (
                    <div className="port-card__placeholder" />
                  )}
                </div>
                <div className="port-card__header">
                  <h3 className="port-card__titulo">{p.titulo}</h3>
                  <span className="port-card__num">{p.num}</span>
                </div>
                <p className="port-card__desc">{p.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PortfolioPage;
